











































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const attr = namespace("attribute");
const commonVuex = namespace("common");

@Component({})
export default class editMultiLanguage extends Vue {
  @commonVuex.State languageList;
  dialogVisible: boolean = false;

  ruleForm: any = {
    mutiLang: ""
  };
  get rules() {
    return {
      option: [
        {
          required: true,
          message: this.$t("Attribute.option_require"),
          trigger: "blur"
        },
        {
          max: 100,
          message: this.$t("Basic.required_100_char")
        }
      ]
    };
  }
  @Prop({ default: false }) editData;

  @Watch("dialogVisible")
  watchDialogVisible(val) {
    let $form: any = this.$refs.form;
    if (val) {
      let $form: any = this.$refs.form;
      $form && $form.clearValidate();
      this.fomatArrayToMutiLang(this.editData);
    } else {
      $form && $form.resetFields();
    }
  }
  handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(valid => {
      if (valid) {
        this.handleConfirm();
      }
    });
  }
  handleConfirm() {
    this.$emit("save", this.fomatMutiLangToArray());
    this.dialogVisible = false;
  }
  // option 转化为接口要的数组格式，传给接口
  fomatMutiLangToArray() {
    let result: any = [];
    let { mutiLang } = this.ruleForm;
    for (let item in mutiLang) {
      let lang = {
        attrValueName: mutiLang[item],
        locale: item
      };
      result.push(lang);
    }
    return result;
  }

  fomatArrayToMutiLang(data) {
    let mutiLang = {};
    this.languageList.forEach((item, index) => {
      this.$set(mutiLang, item.value, index === 0 ? data.attrValueName : "");
    });

    if (data.attrValueLocales) {
      data.attrValueLocales.forEach(item => {
        mutiLang[item.locale] = item.attrValueName;
      });
    }
    this.ruleForm = { mutiLang };
  }
}
